import React, { useEffect, useMemo, useState } from 'react';
import { getContracts } from 'services/contractsServices';
import { HiOutlinePresentationChartBar } from 'react-icons/hi';
import ItemBox from '../ItemBox';

import { Container, AddendumNotFound } from './styles';
import { ContractData } from '../Contract/types';

const Addendum: React.FC = () => {
  const [siteId, setSiteId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [contracts, setContracts] = useState<ContractData[]>([]);

  useEffect(() => {
    async function getSiteId(): Promise<void> {
      const customerSiteId = await localStorage.getItem(
        '@UltragazEmpresarial:customerSiteId'
      );
      if (customerSiteId) {
        setSiteId(customerSiteId);
      }
    }
    if (!siteId) getSiteId();
  }, [siteId]);

  useEffect(() => {
    async function getContractFirst(): Promise<void> {
      setLoading(true);
      const response = await getContracts(siteId);
      setLoading(false);
      setContracts(response);
    }
    if (siteId) getContractFirst();
  }, [siteId]);

  const listItems = useMemo(() => {
    if (contracts?.length === 0) return [];
    return contracts?.filter(
      (conctract) => conctract.contractType === 'Adendo'
    );
  }, [contracts]);

  const handleOpenChat = (): void => {
    const chatbotButton = document?.querySelector(
      '#hi-custom-widget'
    ) as HTMLButtonElement;
    if (chatbotButton) {
      chatbotButton.click();
    }
  };

  return (
    <Container>
      {loading && (
        <AddendumNotFound>Carregando adendos, aguarde...</AddendumNotFound>
      )}
      {!loading && listItems?.length > 0 && (
        <>
          {listItems.map((contractItem) => (
            <ItemBox item={contractItem} siteId={siteId} />
          ))}
        </>
      )}
      {!loading && listItems?.length === 0 && (
        <>
          <AddendumNotFound>
            <span>Adendo não encontrado.</span>
            <span>Ainda está com dúvidas?</span>
            <span>
              Fale com a
              <button type="button" onClick={() => handleOpenChat()}>
                Ully
              </button>
              , nossa assistente virtual.
            </span>
          </AddendumNotFound>
        </>
      )}
    </Container>
  );
};

export default Addendum;
